import { addressGarApi } from '@/api'
import { AddressGarParent, AddressGar } from '@/models'

export default {
  namespaced: true,

  state: {
    addressGarParent: new AddressGarParent()
  },

  getters: {},

  mutations: {
    setAddressGar(state, payload) {
      state.addressGarParent.list.some(item => item.id === payload.id)
        ? state.addressGarParent.update(payload)
        : state.addressGarParent.add(payload)
    },

    clearState(state) {
      state.addressGarParent = new AddressGarParent()
    }
  },

  actions: {
    async GET_ADDRESS_GAR({ commit, dispatch }, payload) {
      try {
        const data = await addressGarApi.findAllByPersonalData({id: payload.id})
        if (data.length) {
          data.forEach(item => commit('setAddressGar', item))
        }
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async CREATE_ADDRESS_GAR({ commit }, payload) {
      try {
        const data = await addressGarApi.create(payload)
        if (data.id) {
          commit('setAddressGar', data)
        }
        return data
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async UPDATE_ADDRESS_GAR({ commit }, payload) {
      try {
        commit('setAddressGar', payload)
        return await addressGarApi.update(payload)
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    }
  }
}
